// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Start Mat-sidenave slider */
.details {
  position: relative;
  font-family: 'Inter Regular';
}

.details .menuBtn {
  line-height: 30px !important;
}

.required {
  color: red;
  font-size: 16px;
}

.forminput .field-input {
  font-family: Roboto;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0px 5px;
  font-size: 14px;
  color: #111111;
  border: 0px solid #fff;
  background: #fff;
}

.forminput .field-inputview {
  color: #111111;
  line-height: 26px;
  padding: 0px 5px;
  width: 100px;
  border: 0.75px solid #A69C9C;
  background: #FFF9F9;
}

.attributediv div {
  color: #787171;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.field-inputtype {
  width: 192px;
  display: block;
  padding: 0px !important;
}

.input-file {
  width: 190px;
}

.forminput,
.attributediv {
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
}

.forminput input {
  border-radius: 5px;

}

input:focus-visible {
 outline: none !important;
}

.igview {
  padding: 0 10px !important;
}


.igview .mat-icon {
  color: #fff;
  vertical-align: middle;
  position: relative;
  top: 2px;
  right: 2px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: #003561;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.mb-5 {
  margin-bottom: 5px !important;
}

.igremove {
  padding: 0px 5px;
  min-width: 25px !important;
}

.disabled-input {
  border-color: #d4d4d4;
  background-color: #fafafa;
}

.form-new {
  max-height: 115px;
  overflow: auto;
  overflow-x: hidden;
}

:host ::ng-deep .show-sidebar {
  height: -webkit-max-content;
  box-shadow: none !important;
  padding: 0px;
  background: #fff;
  position: absolute;
  max-width: 317px;
  bottom: 80px;
  right: 0px !important;
  top: auto;
  z-index: 999;
}

@media screen and (max-width: 380px) {
  .attributediv div {
    width: 100px !important;
  }



  .forminput .field-inputview {
    width: 100px !important;

  }

}

@media screen and (max-width: 420px) {
  .show-sidebar {
    max-width: 285px;
  }
}

.continueDraw {
  /* border: 1px solid #d1c8c8; */
  padding: 0px 10px;
  /* border-radius: 5px; */
}

.attributediv2 {
  width: 158px;
  text-align: center;
}

.attributediv1 {
  width: 100%;
  text-align: center;
}

.mat-raised-group button {
  width: 92px;
}

`, "",{"version":3,"sources":["webpack://./projects/lib-map-common/src/lib/common-poly-nav/common-poly-nav.component.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;;;;EAIA;IACE,uBAAuB;;EAEzB;;AAEF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/*Start Mat-sidenave slider */\n.details {\n  position: relative;\n  font-family: 'Inter Regular';\n}\n\n.details .menuBtn {\n  line-height: 30px !important;\n}\n\n.required {\n  color: red;\n  font-size: 16px;\n}\n\n.forminput .field-input {\n  font-family: Roboto;\n  width: 100%;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding: 0px 5px;\n  font-size: 14px;\n  color: #111111;\n  border: 0px solid #fff;\n  background: #fff;\n}\n\n.forminput .field-inputview {\n  color: #111111;\n  line-height: 26px;\n  padding: 0px 5px;\n  width: 100px;\n  border: 0.75px solid #A69C9C;\n  background: #FFF9F9;\n}\n\n.attributediv div {\n  color: #787171;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.field-inputtype {\n  width: 192px;\n  display: block;\n  padding: 0px !important;\n}\n\n.input-file {\n  width: 190px;\n}\n\n.forminput,\n.attributediv {\n  display: flex;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.forminput input {\n  border-radius: 5px;\n\n}\n\ninput:focus-visible {\n outline: none !important;\n}\n\n.igview {\n  padding: 0 10px !important;\n}\n\n\n.igview .mat-icon {\n  color: #fff;\n  vertical-align: middle;\n  position: relative;\n  top: 2px;\n  right: 2px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #003561;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.mb-5 {\n  margin-bottom: 5px !important;\n}\n\n.igremove {\n  padding: 0px 5px;\n  min-width: 25px !important;\n}\n\n.disabled-input {\n  border-color: #d4d4d4;\n  background-color: #fafafa;\n}\n\n.form-new {\n  max-height: 115px;\n  overflow: auto;\n  overflow-x: hidden;\n}\n\n:host ::ng-deep .show-sidebar {\n  height: -webkit-max-content;\n  box-shadow: none !important;\n  padding: 0px;\n  background: #fff;\n  position: absolute;\n  max-width: 317px;\n  bottom: 80px;\n  right: 0px !important;\n  top: auto;\n  z-index: 999;\n}\n\n@media screen and (max-width: 380px) {\n  .attributediv div {\n    width: 100px !important;\n  }\n\n\n\n  .forminput .field-inputview {\n    width: 100px !important;\n\n  }\n\n}\n\n@media screen and (max-width: 420px) {\n  .show-sidebar {\n    max-width: 285px;\n  }\n}\n\n.continueDraw {\n  /* border: 1px solid #d1c8c8; */\n  padding: 0px 10px;\n  /* border-radius: 5px; */\n}\n\n.attributediv2 {\n  width: 158px;\n  text-align: center;\n}\n\n.attributediv1 {\n  width: 100%;\n  text-align: center;\n}\n\n.mat-raised-group button {\n  width: 92px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
